module.exports = __webpack_public_path__ + "img/bg.dc0c28fd.png";